import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { OfficeOption, PageModel } from '../model/doctor-preference.model';

const baseUrl = '/api/offices';

@Injectable({ providedIn: 'root' })
export class OfficeClient {
    private readonly _http = inject(HttpClient);

    search(search: string | null, take: number): Observable<PageModel<OfficeOption>> {
        let params = new HttpParams().set('take', take);
        if (search != null && search.length > 0) {
            params = params.set('search', search);
        }
        return this._http.get<PageModel<OfficeOption>>(baseUrl, { params });
    }

    listByIds(ids: readonly string[]): Observable<OfficeOption[]> {
        const uniqueIds = [...new Set(ids)];
        if (uniqueIds.length === 0) {
            return of([]);
        }
        let params = new HttpParams().set('take', uniqueIds.length);
        for (const id of uniqueIds) {
            params = params.append('ids', id);
        }
        return this._http.get<PageModel<OfficeOption>>(baseUrl, { params }).pipe(map(page => page.items));
    }
}
